import { motion } from "motion/react";
import { Text } from "../uikit";
import { useTranslation } from "react-i18next";

export default function ErrorMessage({ errorMessage }) {
  const { t, _ } = useTranslation();

  return (
    <motion.div
      animate={{
        height: errorMessage != "" ? "auto" : 0,
        opacity: errorMessage != "" ? 1 : 0,
        marginBottom: errorMessage != "" ? "30px" : 0,
        transition: {
          default: { type: "spring" },
          opacity: { ease: "linear" },
        },
      }}
      transition={{ type: "spring", stiffness: 100 }}
      className="center error"
    >
      <Text>{t(errorMessage)}</Text>
    </motion.div>
  );
}
